import 'nodelist-foreach-polyfill'
import * as utils from './utils.js';

import Header from './modules/header.js';
import Magnet from './modules/magnet.js';

import {initHome} from './pages/home.js';
import {initPage} from './pages/page.js';
import {initAgence} from './pages/agence.js';
import {initCulture} from './pages/culture.js';
import {initMetier} from './pages/metier.js';
import {initProjects} from './pages/projects.js';
import {initProject} from './pages/project.js';

class App {

  constructor(opt = {}) {

    //Declarations
    this.sy = 0;
    this.devMode = false;
    this.DOM = {};
    this.DOM.body = document.body;
    this.DOM.footer = document.querySelector('body > footer');
    this.DOM.barbaWrapper = document.querySelector('#barba-wrapper');
    this.DOM.intro = document.querySelector('.intro__container');

    //Signature Wokine
    window.scrollTo(0,0);
    console.log("%cCreated by Wokine, with ❤","color: #000; padding: 5px 0px 1px; border-bottom:2px solid #71d1c2;"),console.log("%chttp://wokine.com","color:#ccc")

    //DevMode ( infos navigateur )
    if (this.devMode) {
  		console.log('DEVMODE BIATCH');
      console.log(window.Sniff);
    }

    this.init();
    this.addEvents();
    this.intro();

  }

  init() {

    //Resets
    history.scrollRestoration = 'manual';
    this.DOM.body.scrollTop = document.documentElement.scrollTop = 0;
    window.scrollTo(0,0);

    // Create Header
  	const header = new Header(document.querySelector('body > header'));
    this.initMagnets(document.querySelector('body > header'));
    this.initMagnets(document.querySelector('body > footer'));
    this.initMagnets(document.querySelector('body > .loading__container'));

    /*const footer = document.querySelector('body > footer');
    footer.querySelector('.project__call a').addEventListener('click', (e) => {
      e.preventDefault();
      header.DOM.toggleMenu.click();
    })*/

    // Create Footer
    let footerY = 0;
    let footerLerp1 = 0;
    let footerLerp2 = 0;
    let footerLerp3 = 0;
    let footerLerp4 = 0;
    var footerRender = () => {
      if (this.sy < this.DOM.footer.offsetTop - window.innerHeight) return;
      let diff = this.sy - (this.DOM.footer.offsetTop - window.innerHeight);
      footerY =  diff - this.DOM.footer.offsetHeight;
      footerLerp1 = utils.lerp(footerLerp1, footerY, 0.16);
      footerLerp2 = utils.lerp(footerLerp2, footerY, 0.14);
      footerLerp3 = utils.lerp(footerLerp3, footerY, 0.12);
      footerLerp4 = utils.lerp(footerLerp3, footerY, 0.1);
      TweenMax.set(this.DOM.footer.querySelector('.brand'), {y: footerLerp1 });
      TweenMax.set(this.DOM.footer.querySelector('.project__call'), {y: footerLerp2 });
      TweenMax.set(this.DOM.footer.querySelector('.newsletter__call'), {y: footerLerp3 });
      TweenMax.set(this.DOM.footer.querySelector('.block--socials'), {y: footerLerp4 });
    }
    if(window.innerWidth > 767) TweenMax.ticker.addEventListener("tick", footerRender, this, true, 1);

    //Barba
    Barba.Dispatcher.on('newPageReady', (currentStatus, oldStatus, container) => {

      // newPageReady
      console.log(container.classList.contains('page--home'));
      if(!container.classList.contains('page--home')) document.querySelector('body').classList.remove('overflow');

      // Animations
      if (!window.Sniff.features.mobile) {
        this.initPrllx(container);
        this.initMagnets(container);
      }

      this.initInView(container);

    });
    
    Barba.Dispatcher.on('linkClicked', (HTMLElement, MouseEvent) => {

      //linkClicked

    });
    
    Barba.Dispatcher.on('initStateChange', function() {

      //initStateChange
  		if (typeof ga === 'function') {
  			ga('send', 'pageview', location.pathname);
  		}

  	});

    var pageTransition = Barba.BaseTransition.extend({

  		start: function() {

  		  Promise.all([this.newContainerLoading, this.transitionOut()])
  		  .then(this.transitionIn.bind(this));

  		},
      
  		transitionOut: function() {

  			let deferred = Barba.Utils.deferred();
  			let oldContainer = this.oldContainer;

			  const pageOut = new TimelineMax({ paused:true, onStart:()=> {

          document.querySelector('body').classList.add('loading');

        }, onComplete:()=>{

          //Close Menu if Open
          if(header.menuOpen) {
            var click = new Event('click');
            header.DOM.toggleMenu.dispatchEvent(click);
          }

          window.scrollTo(0,0);
				  deferred.resolve();

			  }});

        pageOut.fromTo('body > .loading__color', 0.7, {x:"-100%"}, {x:"0%", ease:Power3.easeInOut, clearProps:"all"}, 0);
        pageOut.fromTo('body > .loading__container', 0.8, {x:"-100%"}, {x:"0%", ease:Power3.easeInOut}, 0);
        pageOut.fromTo('body > .loading__container .wrapper', 0.8, {x:"-25%", skewY:"-20deg", skewX:"20deg"}, {x:"0%", skewY:"0deg", skewX:"0deg", ease:Power3.easeInOut, clearProps:"all"}, 0.2);
        pageOut.to('.barba-container', 0.8, {transform: 'translateX(50vw)', ease:Power3.easeIn, clearProps:"all"}, 0);
        pageOut.play();

  			return deferred.promise;

  		},
      
  		transitionIn: function() {

  			var _this = this;

  			this.oldContainer.style.display = "none";
  			this.newContainer.style.visibility = 'visible';
        window.scrollTo(0,0);

		    const pageIn = new TimelineMax({ paused:true, onComplete:()=>{
          document.querySelector('body').classList.remove('loading');
					_this.done();
				}, delay:1})

        pageIn.to('body > .loading__color', 0.9, {x:"100%", ease:Power3.easeInOut, clearProps:"all"}, 0);
        pageIn.to('body > .loading__container', 0.8, {x:"100%", ease:Power3.easeInOut, clearProps:"all"}, 0);
        pageIn.to('body > .loading__container .wrapper', 0.8, {x:"-25%", skewY:"20deg",skewX:"-20deg", ease:Power3.easeInOut, clearProps:"all"}, 0);
        pageIn.fromTo('.barba-container', 0.9, {transform: 'translateX(-50vw)'}, {transform: 'translateX(0vw)', ease:Power3.easeOut, clearProps:"all"}, 0);
        pageIn.play();

  		}

  	});

  	Barba.Pjax.getTransition = function() {
  	  return pageTransition;
  	};

  	//routes
  	initHome();
  	initPage();
  	initAgence();
  	initCulture();
  	initMetier();
    initProjects();
    initProject();

    Barba.Pjax.start();

  }

  addEvents() {

    window.addEventListener('scroll', (e) => {
  		this.sy = window.pageYOffset || document.documentElement.scrollTop;
  	});
    
    document.addEventListener('lazyloaded', function (e)  {
      if (document.querySelector('.barba-container').classList.contains('page--home')) {
        if (e.target.classList.contains('video--cover')) e.target.play();
      }
    });

  }

  initMagnets(container) {

	  const magnets = container.querySelectorAll('*[data-magnet]');
	  magnets.forEach((item) => {
		    let magnet = new Magnet(item);
	  });

  }

  initPrllx(container) {

      const TLPrllxs = []
      const prllxs = container.querySelectorAll('*[data-prllx]');
      if (!prllxs) return;
      prllxs.forEach((item) => {

          let prllxTL = new TimelineMax({paused: true});
          if (!item.getAttribute('data-prllxSimple')) TweenMax.set(item, {y: -1 * item.getAttribute('data-prllx')});
          prllxTL.to(item, 1, {y: item.getAttribute('data-prllx'), overwrite: "all", ease: Power0.easeNone});
          TLPrllxs.push(prllxTL);

      });

      var prllxRender = function () {

          prllxs.forEach((item, index) => {
              let from = Math.round(item.getBoundingClientRect().top + this.sy - window.innerHeight);
              if (item.getAttribute('data-prllxSimple')) from = 0;
              let to = Math.round(item.getBoundingClientRect().top + this.sy + item.offsetHeight);
              let norm = utils.clamp(utils.normalize(this.sy, from, to), 0, 1);
              TLPrllxs[index].progress(norm);
          });

      }

      TweenMax.ticker.addEventListener("tick", prllxRender, this, true, 1);

  }

  initInView(container) {

    const animationDuration = 1.2;
    //console.log("initInView");

    //fadeIn
    /*const fadeInElems = container.querySelectorAll('.fadeInView');

    if (fadeInElems) {
      fadeInElems.forEach((elem) => {
        elem.fadeInTL = new TimelineMax({ paused: true});
        elem.fadeInTL.from(elem, 1, {y:80, opacity:0, ease:Power3.easeOut}, 0);
      })*/

      inView(".fadeInView").on('enter', el => {
        if(!el.done)  el.classList.add('visible')
      }).on('exit', el => {
        el.done = true;
        //el.fadeInTL.duration(0.2).reverse();
      });

    //}

    //letterIn
    const lettersInElems = container.querySelectorAll('.lettersInView');
    if (lettersInElems) {

      lettersInElems.forEach((elem) => {
        elem.splitLetters = new SplitText(elem, {type:"chars"});
        elem.lettersInTL = new TimelineMax({ paused: true});
        elem.lettersInTL.staggerFrom(elem.splitLetters.chars, 1, {y:20, opacity:0, ease:Power3.easeOut}, 0.015, 0);
      })

      inView(".lettersInView").on('enter', el => {
        if(!el.done)  el.lettersInTL.duration(animationDuration).play();
      }).on('exit', el => {
        el.done = true;
        el.innerHTML = el.splitLetters._originals;
        //el.lettersInTL.duration(0.2).reverse();
      });

    }

    //linesIn
    const linesInElems = container.querySelectorAll('.linesInView');
    if (linesInElems) {

      linesInElems.forEach((elem) => {
        elem.splitLines = new SplitText(elem, {type:"lines"});
        elem.linesInTL = new TimelineMax({ paused: true});
        elem.linesInTL.staggerFrom(elem.splitLines.lines, 1, {y:20, opacity:0, ease:Power3.easeOut}, 0.05, 0.2);
      })

      inView(".linesInView").on('enter', el => {
        if(!el.done)  el.linesInTL.duration(animationDuration * 1.5).play();
      }).on('exit', el => {
        el.done = true;
        el.innerHTML = el.splitLines._originals;
        //el.linesInTL.duration(0.2).reverse();
      });

    }

    inView.offset({
        top: -120,
        left:-50,
        right:-50,
        bottom: 0,
    });

  }

  intro() {

    if (document.querySelector('.barba-container').classList.contains('page--home')) {

      const intro = new TimelineMax({ paused:true, delay:0.2,
        onStart:()=>{
          this.DOM.body.classList.remove('is-loading');
        }, onComplete:() => {
          console.log(this.DOM.intro.parentNode);
          this.DOM.intro.parentNode.removeChild(this.DOM.intro);
        }
      });

      intro.from(this.DOM.intro.querySelector('.baseline'), 1.6, {opacity:0, x:100, ease:Power3.easeOut, clearProps:"all"}, 1.2);
      intro.add(() => {
        this.DOM.intro.querySelector('.names').classList.remove('first');
      }, 1);

      const introNames = this.DOM.intro.querySelectorAll('.names > *');
      let delayTime;

      introNames.forEach((elem, index) => {
        delayTime = index * 2;
        intro.add(() => {
          if (this.DOM.intro.querySelector('.active')) this.DOM.intro.querySelector('.active').classList.remove('active');
          introNames[index].classList.add('active');
          TweenMax.to(this.DOM.intro.querySelector('.names'), 0.8, {width:introNames[index].offsetWidth, ease:Power3.easeOut});
        }, 1 + delayTime);
      });

      intro.to(this.DOM.intro, 1, {x:"100%", ease:Power3.easeInOut, clearProps:"all"}, delayTime + 3);
      intro.from(".barba-container", 1, {x:"-50%", ease:Power3.easeOut, clearProps:"all"}, delayTime + 3);
      
      /*const videoIntro = document.querySelector('.hero .showreel .video--cover');
      if (videoIntro) {
        
        videoIntro.load();
        videoIntro.addEventListener('canplay', (e) => {
          intro.play();
          videoIntro.play();
        });
        
        videoIntro.addEventListener('error', (e) => {
          intro.play();
        });

      } else {
        intro.play();
      }*/
      
      intro.play();


    } else {


      const intro = new TimelineMax({ paused:true,
        onStart:()=>{
          this.DOM.body.classList.remove('is-loading');
          document.querySelector('body').classList.add('loading');
        }, onComplete:() => {
          document.querySelector('body').classList.remove('loading');
        }
      });
      intro.fromTo('body > .loading__container', 0.8, {x:"0%"}, {x:"100%", ease:Power3.easeInOut, clearProps:"all"}, 1);
      intro.fromTo('body > .loading__color', 0.9, {x:"0%"}, {x:"100%", ease:Power3.easeInOut, clearProps:"all"}, 1);
      intro.fromTo('.barba-container', 0.9, {transform: 'translateX(-50vw)'}, {transform: 'translateX(0vw)', ease:Power3.easeOut, clearProps:"all"}, 1);
      intro.play();
      
      

    }

  }

}

const app = new App();
